import { useState } from 'react'
import { message } from 'antd'
import type { RFQ, Bid } from '../types/rfq.types'

export const useRFQActions = () => {
    const [selectedRFQ, setSelectedRFQ] = useState<RFQ | null>(null)
    const [isDetailDrawerOpen, setIsDetailDrawerOpen] = useState(false)

    const handleViewDetails = (rfq: RFQ) => {
        setSelectedRFQ(rfq)
        setIsDetailDrawerOpen(true)
    }

    const handleAcceptBid = (bid: Bid) => {
        message.success(`Bid from ${bid.merchantName} accepted!`)
        setIsDetailDrawerOpen(false)
    }

    const handleRejectBid = (bid: Bid) => {
        message.info(`Bid from ${bid.merchantName} rejected!`)
    }
    
    const closeDrawer = () => setIsDetailDrawerOpen(false)

    return {
        selectedRFQ,
        isDetailDrawerOpen,
        handleViewDetails,
        handleAcceptBid,
        handleRejectBid,
        closeDrawer
    }
}
